import React, { useState } from 'react';
import './InsightsGrid.css';

// Import icons and the four new images
import { FiEye, FiClock, FiCalendar, FiArrowRight } from 'react-icons/fi';
import priceIndexImg from '../../assets/images/insight-price-index.png';
import spotPricesImg from '../../assets/images/insight-spot-prices.png';
import seasonalityImg from '../../assets/images/insight-seasonality.png';
import centralStockImg from '../../assets/images/insight-central-stock.png';


// --- UPDATED allInsightsData array ---
const allInsightsData = [
  {
    category: 'Grains',
    image: priceIndexImg,
    title: "India's Wheat Price Index: Tracking the average price of major origins.",
    reads: '35 Reads',
    readTime: '2 Min',
    date: 'November 05, 2025'
  },
  {
    category: 'Grains',
    image: spotPricesImg,
    title: 'Spot Prices: A look at wheat prices in key markets like Bareilly, Kota, and Indore.',
    reads: '42 Reads',
    readTime: '3 Min',
    date: 'November 05, 2025'
  },
  {
    category: 'Oilseeds',
    image: seasonalityImg,
    title: 'Price Seasonality for Wheat in Delhi compared to the 5-year average.',
    reads: '58 Reads',
    readTime: '4 Min',
    date: 'November 05, 2025'
  },
  {
    category: 'Sugar',
    image: centralStockImg,
    title: 'Central Pool Stock: Indian wheat stocks reported at 34.7 million tonnes.',
    reads: '29 Reads',
    readTime: '2 Min',
    date: 'November 05, 2025'
  },
  // You can add more articles for other categories here to make the tabs work
  {
    category: 'Grains',
    image: priceIndexImg,
    title: "India's Wheat Price Index: Tracking the average price of major origins.",
    reads: '35 Reads',
    readTime: '2 Min',
    date: 'November 05, 2025'
  },
  {
    category: 'Grains',
    image: spotPricesImg,
    title: 'Spot Prices: A look at wheat prices in key markets like Bareilly, Kota, and Indore.',
    reads: '42 Reads',
    readTime: '3 Min',
    date: 'November 05, 2025'
  },
  {
    category: 'Oilseeds',
    image: seasonalityImg,
    title: 'Price Seasonality for Wheat in Delhi compared to the 5-year average.',
    reads: '58 Reads',
    readTime: '4 Min',
    date: 'November 05, 2025'
  },
  {
    category: 'Sugar',
    image: centralStockImg,
    title: 'Central Pool Stock: Indian wheat stocks reported at 34.7 million tonnes.',
    reads: '29 Reads',
    readTime: '2 Min',
    date: 'November 05, 2025'
  },

  
  {
    category: 'Oilseeds',
    image: seasonalityImg,
    title: 'Price Seasonality for Wheat in Delhi compared to the 5-year average.',
    reads: '58 Reads',
    readTime: '4 Min',
    date: 'November 05, 2025'
  },
  {
    category: 'Sugar',
    image: centralStockImg,
    title: 'Central Pool Stock: Indian wheat stocks reported at 34.7 million tonnes.',
    reads: '29 Reads',
    readTime: '2 Min',
    date: 'November 05, 2025'
  },


  {
    category: 'Oilseeds',
    image: seasonalityImg,
    title: 'Price Seasonality for Wheat in Delhi compared to the 5-year average.',
    reads: '58 Reads',
    readTime: '4 Min',
    date: 'November 05, 2025'
  },
  {
    category: 'Sugar',
    image: centralStockImg,
    title: 'Central Pool Stock: Indian wheat stocks reported at 34.7 million tonnes.',
    reads: '29 Reads',
    readTime: '2 Min',
    date: 'November 05, 2025'
  },

   {
    category: 'Pulses',
    image: seasonalityImg,
    title: 'Price Seasonality for Wheat in Delhi compared to the 5-year average.',
    reads: '58 Reads',
    readTime: '4 Min',
    date: 'November 05, 2025'
  },
  {
    category: 'Pulses',
    image: centralStockImg,
    title: 'Central Pool Stock: Indian wheat stocks reported at 34.7 million tonnes.',
    reads: '29 Reads',
    readTime: '2 Min',
    date: 'November 05, 2025'
  },


  {
    category: 'Pulses',
    image: seasonalityImg,
    title: 'Price Seasonality for Wheat in Delhi compared to the 5-year average.',
    reads: '58 Reads',
    readTime: '4 Min',
    date: 'November 05, 2025'
  },
  {
    category: 'Pulses',
    image: centralStockImg,
    title: 'Central Pool Stock: Indian wheat stocks reported at 34.7 million tonnes.',
    reads: '29 Reads',
    readTime: '2 Min',
    date: 'November 05, 2025'
  },

   {
    category: 'Spices',
    image: seasonalityImg,
    title: 'Price Seasonality for Wheat in Delhi compared to the 5-year average.',
    reads: '58 Reads',
    readTime: '4 Min',
    date: 'November 05, 2025'
  },
  {
    category: 'Spices',
    image: centralStockImg,
    title: 'Central Pool Stock: Indian wheat stocks reported at 34.7 million tonnes.',
    reads: '29 Reads',
    readTime: '2 Min',
    date: 'November 05, 2025'
  },


  {
    category: 'Spices',
    image: seasonalityImg,
    title: 'Price Seasonality for Wheat in Delhi compared to the 5-year average.',
    reads: '58 Reads',
    readTime: '4 Min',
    date: 'November 05, 2025'
  },
  {
    category: 'Spices',
    image: centralStockImg,
    title: 'Central Pool Stock: Indian wheat stocks reported at 34.7 million tonnes.',
    reads: '29 Reads',
    readTime: '2 Min',
    date: 'November 05, 2025'
  },
];

const InsightsGrid = () => {
  const [activeCategory, setActiveCategory] = useState('Grains');

  // Filter the articles based on the active category
  // If the active category has no items, it will show an empty state.
  const filteredInsights = allInsightsData.filter(item => item.category === activeCategory);

  return (
    <section className="insights-grid-section">
      <div className="insights-container">
        <div className="section-header">
          <h2>Stay informed, stay ahead</h2>
          <div className="header-line"></div>
        </div>
        <p className="section-subtitle">
          CRISHI offers sharp market insights, empowering confident decisions in the agriculture industry.
        </p>

        <div className="insights-tabs">
          <button onClick={() => setActiveCategory('Grains')} className={activeCategory === 'Grains' ? 'active' : ''}>Grains</button>
          <button onClick={() => setActiveCategory('Oilseeds')} className={activeCategory === 'Oilseeds' ? 'active' : ''}>Oilseeds</button>
          <button onClick={() => setActiveCategory('Sugar')} className={activeCategory === 'Sugar' ? 'active' : ''}>Sugar</button>
          <button onClick={() => setActiveCategory('Pulses')} className={activeCategory === 'Pulses' ? 'active' : ''}>Pulses</button>
          <button onClick={() => setActiveCategory('Spices')} className={activeCategory === 'Spices' ? 'active' : ''}>Spices</button>
        </div>

        <div className="insights-grid">
          {filteredInsights.length > 0 ? (
            filteredInsights.map((item, index) => (
              <div key={index} className="insight-card">
                <div className="insight-card-image">
                  <img src={item.image} alt={item.title} />
                </div>
                <div className="insight-card-content">
                  <h3>{item.title}</h3>
                  <div className="insight-meta">
                    <span><FiEye /> {item.reads}</span>
                    <span><FiClock /> {item.readTime}</span>
                    <span><FiCalendar /> {item.date}</span>
                  </div>
                  < div className="read-more-link">
                    Read more <FiArrowRight />
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="no-insights-message">No insights available for this category yet.</p>
          )}
        </div>
      </div>
      <div className="explore-more-container">
        <button className="explore-more-btn">Explore more</button>
      </div>
    </section>
  );
};

export default InsightsGrid;